import './style.css'
import * as THREE from 'three'
import {GLTFLoader} from "../GLTFLoader.js"
import { Light } from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
const { noise, noiseSeed } = require('@chriscourses/perlin-noise')
noiseSeed(fxrand()*9999999)

// SCROLL TO ZOOM IN AND OUT, SHIFT+CLICK AND DRAG TO MOVE SIDEWAYS, CLICK AND DRAG TO ROTATE
// PRESS 'R' TO RESET CAMERA POSITION
// PRESS 'E' TO ENABLE 3D EFFECT (3D GLASSES RECOMMENDED)

let pIndex = Math.floor(getRandom(0,2)) //PICKS A COLOR PALLETE
let cIndex //PICKS A COLOR WITHIN A PALLETE
let cDec // RETURNS COLOR

let width= window.innerWidth
let height = window.innerHeight

let bgColor = new THREE.Color(0x000000)
let bgDec = Math.floor(getRandom(0,5))

let rotFact = getRandom(0,360) // ROTATION FACTOR FOR ALL .GLB's
let camPosY = getRandom(0.5,5)
let inc = 0 //increment

let cbs= ['./1.glb','./2.glb','./3.glb', './4.glb', './5.glb', './6.glb', './7.glb', './8.glb', './9.glb', './10.glb']  // Array of GLB's
let composer
let effect = false
let vertCount = Math.floor(getRandom(12,45))

const loader = new GLTFLoader()




//SCENE
const scene = new THREE.Scene()
colorPallete()
if(bgDec == 0){
  scene.background = bgColor
}else{
scene.background = new THREE.Color(cDec)
}


//CAMERA
const camera = new THREE.PerspectiveCamera(25,width/height,0.01,1000)
scene.add(camera)


//RENDERER
const renderer = new THREE.WebGLRenderer()
renderer.setSize(width,height)
document.body.appendChild(renderer.domElement)
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 0.7


//Orbit Controls
const controls = new OrbitControls(camera, renderer.domElement)
camera.position.z=5
if(bgDec==0){
camera.position.y = 3
}
else{
camera.position.y=camPosY
}


controls.saveState()
controls.update()
camera.lookAt(0,0,0)
document.addEventListener('keydown', (event) => {  //Press 'R' to reset Camera Position
    var name = event.key;
    var code = event.code;
    if (name === 'r' || name === 'R') {
      controls.reset()
      controls.update()
      
      return;
    }
  }, false);
 
console.log(camera.position.y)

//FOG
let fogColor
if(bgDec == 0){
fogColor = 0x000000
}else{
 fogColor = new THREE.Color(cDec)
}

scene.fog = new THREE.FogExp2(fogColor,0.15)


//LIGHTS
const dirLight = new THREE.DirectionalLight('#E76F51',4)
const Target = new THREE.Object3D()
scene.add(Target)
Target.position.x=-50
Target.position.z=100
Target.position.y=-100
dirLight.target= Target
scene.add(dirLight)
colorPallete()
const hemiLight = new THREE.HemisphereLight(cDec,0x000000,2)
scene.add(hemiLight)

//POINTS
let x,y,z
const ptsGeometry = new THREE.BufferGeometry()
let pts = []
for(let i=0;i<vertCount;i++){
  x=getRandom(-3,3)
  y=getRandom(-3,3)
  z=getRandom(-3,3)
  pts[i] = (x,y,z)
}
ptsGeometry.setAttribute('position', new THREE.Float32BufferAttribute(pts,3))
const ptsmaterial = new THREE.PointsMaterial({color : 0xffffff,size : 0.1, sizeAttenuation: true, alphaTest: 0.5, transparent: true})
const prtcls = new THREE.Points(ptsGeometry,ptsmaterial)
scene.add(prtcls)

//LINES
colorPallete()
const lnMaterial = new THREE.MeshBasicMaterial( { color: 0xffffff } );
const lnGeometry = new THREE.BufferGeometry().setFromPoints(pts)
lnGeometry.setAttribute('position', new THREE.Float32BufferAttribute(pts,3))
const line = new THREE.Line(lnGeometry,lnMaterial)
scene.add(line)

//GLB
let bldCount = getRandom(15,20)
for(let i=0;i<bldCount;i++){

  let posFactX = getRandom(-3,3)
let posFactZ = getRandom(-3,1.5)

let cubeDec = Math.floor(getRandom(0,cbs.length))
console.log(cbs[cubeDec])
let model
loader.load( cbs[cubeDec], function(gltf){
    model = gltf.scene
    model.rotation.y = rotFact
    model.position.x=posFactX
    model.position.z=posFactZ
    scene.add(model)
})
}


// WIND PARTICLES
const vertices = []

for(let i=0;i <10000 ; i++){
  vertices[i] = (getRandom(-5,5),getRandom(-5,5),getRandom(-5,5))
}

const geometry = new THREE.BufferGeometry()
geometry.setAttribute( 'position' , new THREE.Float32BufferAttribute(vertices,3))

colorPallete()
const material = new THREE.PointsMaterial({size:getRandom(0.005,0.1), color : cDec})

const points = new THREE.Points (geometry,material)
scene.add(points)


//Post Processing
document.addEventListener('keydown', (event) =>{
  var key = event.key
  if(key =='e' || key =='E'){
    addEffect()
    
  }
  })
				composer = new EffectComposer(renderer)
        const renderScene = new RenderPass( scene, camera );
        composer.addPass(renderScene)

        const effect2 = new ShaderPass( RGBShiftShader );
        
				effect2.uniforms[ 'amount' ].value = 0.005;

        const bloomPass = new UnrealBloomPass( new THREE.Vector2(width,height),1.5,0.4,0.85)
bloomPass.threshold = 0.3;
bloomPass.strength = 0.6;
bloomPass.radius = 0.2;

composer.addPass(bloomPass)
  
        
        composer.setSize( width,height );
        window.addEventListener( 'resize', onWindowResize );

        function addEffect(event) {
    
          if(effect){
          effect = false;
          composer.removePass(effect2)
          }
          else{
            effect = true
            composer.addPass(effect2)
          }
        }
        
        function onWindowResize() {

          camera.aspect = width/height;
          camera.updateProjectionMatrix();
  
          renderer.setSize( width,height);
          composer.setSize( width,height );
  
        }


//GET MOUSEX, MOUSE Y
let mouseX
let mouseY
function saveMouse(event){
	mouseX = event.clientX;
	mouseY = event.clientY;
}
document.onmousemove = saveMouse


//MAP RANGE FUNCTION
function mapRange (number, inMin, inMax, outMin, outMax) {
  return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}

fxpreview()

//ANIMATION

function animate(){

inc++
let rtX = mapRange(noise(inc/1000),0,1,-0.5,0.5); //
let rtY = mapRange(noise(inc/1000),0,1,-0.5,0.5);    //
let rtZ = mapRange(noise(inc/1000),0,1,-0.5,0.5); //

    requestAnimationFrame( animate )
    points.position.x+=0.01

    prtcls.rotation.y+=rtY/50 //
    prtcls.rotation.x+=rtX/50
    prtcls.rotation.z+=rtZ/50    //
    line.rotation.y+=rtY/50
    line.rotation.x+=rtX/50
    line.rotation.z+=rtZ/50 //

    if(points.position.x>5){
      points.position.x=0
    }
    composer.render()
}
animate()

//Color Pallete
function colorPallete(){
  //Insert palletes{
    let cor=['#39456A', '#5E454D', '#4D3C05', '#4C2E05', '#97410C'];
  let cor1=['#450D00', '#00524E', '#72090E', '#1E475C', '#3D3D3D'];
  //...}
  cIndex=Math.floor(getRandom(0,cor.length)) //Pick a color
  
  
  //Returns cDec{
  if(pIndex==0){
    cDec=cor[cIndex]
  }
  if(pIndex==1){
    cDec=cor1[cIndex]
  }
  //...}
  }

  function getRandom(min, max) {
    return fxrand() * (max - min) + min;
  }
  